import { Directive, ElementRef, HostListener, input, inject } from '@angular/core';

@Directive({ selector: '[tdSidebarMenu]' })
export class TdSidebarMenuDirective {
  elementRef = inject(ElementRef);


  readonly sidebarHoverClass = input<string>(undefined);
  readonly sidebarElement = input<HTMLElement>(undefined);
  readonly sidebarScrollClass = input<string>(undefined);

  private prevScrollPos;

  @HostListener('mouseover')
  onMouseOver() {
    const sidebarHoverClass = this.sidebarHoverClass();
    if (this.sidebarElement().classList.contains('closed-menu') && !this.elementRef.nativeElement.classList.contains(sidebarHoverClass)){
      this.elementRef.nativeElement.classList.add(sidebarHoverClass);
    }
  }

  @HostListener('mouseout')
  onMouseOut() {
    const sidebarHoverClass = this.sidebarHoverClass();
    if (this.elementRef.nativeElement.classList.contains(sidebarHoverClass)){
      this.elementRef.nativeElement.classList.remove(sidebarHoverClass);
    }
  }

  @HostListener('window:scroll', ['$event'])
  onWindowScroll(event){
   const curScroll = window.scrollY;
   if (this.prevScrollPos > curScroll){
     const sidebarScrollClass = this.sidebarScrollClass();
     if (this.elementRef.nativeElement.classList.contains(sidebarScrollClass)) {
       this.elementRef.nativeElement.classList.remove(sidebarScrollClass);
     }

   } else {
     const sidebarScrollClass = this.sidebarScrollClass();
     if (!this.elementRef.nativeElement.classList.contains(sidebarScrollClass)) {
       this.elementRef.nativeElement.classList.add(sidebarScrollClass);
     }
   }
   this.prevScrollPos = curScroll;
  }
}
